import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollReveal from '@/components/base/ScrollReveal';
import CountUp from '@/components/base/CountUp';
import ParticleBackground from '@/components/base/ParticleBackground';

const milestones = [
  { date: '2025.09', title: '赛道布局', desc: '创始团队完成文化数字化赛道深度调研与战略方向确定' },
  { date: '2025.12', title: '战略锚定', desc: '正式确立"地域文化数字资产重构与运营"企业定位' },
  { date: '2026.01', title: '知乎官方合作伙伴', desc: '成为知乎官方战略合作伙伴，开启内容平台生态联动' },
  { date: '2026.02', title: '文化素材系统化整理', desc: '启动山西本土文化素材系统化整理与数字化研发' },
  { date: '2026.04', title: '迁址巨燕商务广场', desc: '公司迁址晋中市榆次区巨燕商务广场，扩大办公规模' },
  { date: '2026.05', title: 'AI工业化平台落地', desc: '自研AI短剧/漫剧工业化SOP生产标准平台正式落地运行' },
  { date: '2026.06', title: '资产库1.0建成', desc: '山西非遗文化数字资产库1.0建成；携手舌尖味道达成全国独家运营战略合作' },
  { date: '2026.07', title: '文化出海启航', desc: '启动"山西故事文化出海计划"，布局全球文化传播' },
  { date: '2026.08', title: '联盟赋能', desc: '作为冯全普·县域AI+OPC联盟核心成员，深度参与全国OPC社区网络建设' },
];

export default function About() {
  return (
    <div className="ui-page">
      <Navbar />
      <main className="pt-20">
        {/* Hero */}
        <section className="relative py-20 md:py-28 overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-b from-background-900/50 to-transparent"></div>
          <ParticleBackground compact />
          <div className="w-full px-4 md:px-8 lg:px-12 relative z-10">
            <div className="max-w-screen-2xl mx-auto">
              <ScrollReveal>
                <div className="text-center mb-16">
                  <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/10 border border-primary-500/20 mb-6">
                    <span className="w-1 h-1 rounded-full bg-primary-500"></span>
                    <span className="text-primary-300 text-xs font-medium tracking-wider whitespace-nowrap">About Us</span>
                  </div>
                  <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-primary-500 mb-6">关于我们</h1>
                  <p className="text-secondary-400 text-lg max-w-2xl mx-auto">立足山西、辐射全国，专注地域文化数字资产重构与运营</p>
                </div>
              </ScrollReveal>
            </div>
          </div>
        </section>

        {/* Stats Bar */}
        <section className="py-12 md:py-16">
          <div className="w-full px-4 md:px-8 lg:px-12">
            <div className="max-w-screen-2xl mx-auto">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                {[
                  { value: 117, suffix: '', label: '县域文化数字资产库', prefix: '' },
                  { value: 100, suffix: '+', label: '精品AI短剧/漫剧', prefix: '' },
                  { value: 9, suffix: '', label: '关键发展里程碑', prefix: '' },
                  { value: 5, suffix: '', label: '核心资质与背书', prefix: '' },
                ].map((stat) => (
                  <ScrollReveal key={stat.label}>
                    <div className="group bg-background-900/50 rounded-2xl border border-primary-500/10 p-6 md:p-8 text-center hover:border-primary-500/25 hover:-translate-y-2 transition-all duration-500 hover:shadow-[0_0_30px_rgba(180,140,80,0.12)]">
                      <div className="font-heading text-3xl md:text-4xl font-bold text-primary-500 mb-2">
                        <CountUp end={stat.value} duration={2000} suffix={stat.suffix} />
                      </div>
                      <p className="text-secondary-400 text-xs md:text-sm">{stat.label}</p>
                    </div>
                  </ScrollReveal>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Brand Interpretation */}
        <section className="py-16 md:py-24 bg-background-900">
          <div className="w-full px-4 md:px-8 lg:px-12">
            <div className="max-w-screen-2xl mx-auto">
              <ScrollReveal>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50 mb-12 text-center">品牌解读</h2>
              </ScrollReveal>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                {[
                  { char: '晋', title: '起于三晋', desc: '根植华夏文明之源，立足山西深厚的文化沃土，汲取千年历史养分。' },
                  { char: '铧', title: '智以AI为犁', desc: '以人工智能技术为犁铧，深耕九州文化沃土，开拓文化数字化新疆域。' },
                  { char: '叙梦', title: '持数字光影', desc: '以数字技术与光影艺术，传颂亿万中国故事，让文化记忆永续流传。' },
                ].map((item) => (
                  <div key={item.char} className="group bg-background-800/40 rounded-2xl border border-primary-500/10 p-8 md:p-10 text-center hover:border-primary-500/25 hover:-translate-y-2 transition-all duration-500 hover:shadow-[0_0_30px_rgba(180,140,80,0.12)]">
                    <div className="font-heading text-5xl md:text-6xl font-bold text-primary-500 mb-4 group-hover:scale-110 transition-transform duration-500">{item.char}</div>
                    <h3 className="text-foreground-50 font-semibold text-lg mb-3 group-hover:text-primary-500 transition-colors duration-500">{item.title}</h3>
                    <p className="text-secondary-400 text-sm leading-relaxed">{item.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Company Profile */}
        <section className="py-16 md:py-24">
          <div className="w-full px-4 md:px-8 lg:px-12">
            <div className="max-w-screen-2xl mx-auto">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                <ScrollReveal>
                  <div className="relative rounded-2xl overflow-hidden border border-primary-500/10 group">
                    <img
                      src="https://readdy.ai/api/search-image?query=Modern%20Chinese%20tech%20company%20office%20interior%20with%20cultural%20elements%2C%20warm%20golden%20lighting%2C%20professional%20workspace%2C%20Shanxi%20cultural%20decorations%2C%20clean%20modern%20design%2C%20corporate%20headquarters%20aesthetic%2C%20dark%20accents%2C%20no%20text&width=800&height=600&seq=about-office-06&orientation=landscape"
                      alt="晋铧叙梦办公环境"
                      className="w-full h-auto object-cover transition-transform duration-700 group-hover:scale-105"
                    />
                  </div>
                </ScrollReveal>
                <ScrollReveal>
                  <div className="group bg-background-900/50 rounded-2xl border border-primary-500/10 p-8 md:p-10 hover:border-primary-500/25 transition-all duration-500 hover:shadow-[0_0_30px_rgba(180,140,80,0.12)]">
                    <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50 mb-6">企业简介</h2>
                    <div className="space-y-4 text-secondary-300 text-sm leading-relaxed">
                      <p>晋铧叙梦（山西）文化科技有限公司是一家科创型文化企业，聚焦<strong className="text-foreground-100 font-medium">县域文化数字化、AIGC内容工业化生产、文旅IP赋能、品牌商业增值</strong>四大核心领域。</p>
                      <p>公司立足山西，已建成<strong className="text-primary-500 font-semibold">山西117个县域文化数字资产库1.0</strong>，同步推进AI短剧/漫剧工业化量产、城市文旅IP孵化宣发、品牌文化赋能与流量电商运营等业务。</p>
                      <p>2026年7月，正式启动<strong className="text-foreground-100 font-medium">"山西故事文化出海计划"</strong>，以山西117个县域文化资源为内容源，以AI数字光影内容为载体，布局全球文化传播。</p>
                      <p>核心团队深耕AIGC内容创作、文旅数字化、品牌运营、跨境传播与产教融合多年，兼具技术研发、内容创作与商业落地经验，并深度参与联盟OPC社区建设与人才培养体系。</p>
                    </div>
                  </div>
                </ScrollReveal>
              </div>
            </div>
          </div>
        </section>

        {/* Mission & Vision */}
        <section className="py-16 md:py-24 bg-background-900">
          <div className="w-full px-4 md:px-8 lg:px-12">
            <div className="max-w-screen-2xl mx-auto">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <ScrollReveal>
                  <div className="group bg-background-800/40 rounded-2xl border border-accent-500/15 p-8 md:p-10 h-full hover:border-accent-500/30 hover:-translate-y-2 transition-all duration-500 hover:shadow-[0_0_30px_rgba(200,120,50,0.12)]">
                    <div className="w-12 h-12 rounded-xl bg-accent-500/15 flex items-center justify-center mb-5 group-hover:bg-accent-500/25 group-hover:scale-110 transition-all duration-500">
                      <i className="ri-flag-line text-accent-500 text-xl"></i>
                    </div>
                    <h3 className="font-heading text-xl font-semibold text-foreground-50 mb-4 group-hover:text-accent-400 transition-colors duration-500">核心使命</h3>
                    <p className="text-secondary-300 text-base leading-relaxed">让每一寸土地的文化记忆，在数字时代被留存、被看见、被传颂。让每一部作品都有根脉，每一次交付都有底气。</p>
                  </div>
                </ScrollReveal>
                <ScrollReveal>
                  <div className="group bg-background-800/40 rounded-2xl border border-primary-500/15 p-8 md:p-10 h-full hover:border-primary-500/30 hover:-translate-y-2 transition-all duration-500 hover:shadow-[0_0_30px_rgba(180,140,80,0.12)]">
                    <div className="w-12 h-12 rounded-xl bg-primary-500/15 flex items-center justify-center mb-5 group-hover:bg-primary-500/25 group-hover:scale-110 transition-all duration-500">
                      <i className="ri-eye-line text-primary-500 text-xl"></i>
                    </div>
                    <h3 className="font-heading text-xl font-semibold text-foreground-50 mb-4 group-hover:text-primary-500 transition-colors duration-500">战略愿景</h3>
                    <p className="text-secondary-300 text-base leading-relaxed">短期深耕山西，中期全国复制，长期成为县域文化数字资产领域标准制定者与生态构建者。</p>
                  </div>
                </ScrollReveal>
              </div>
            </div>
          </div>
        </section>

        {/* Timeline */}
        <section className="py-16 md:py-24">
          <div className="w-full px-4 md:px-8 lg:px-12">
            <div className="max-w-screen-2xl mx-auto">
              <ScrollReveal>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50 mb-12 text-center">发展历程</h2>
              </ScrollReveal>
              <div className="relative">
                <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-primary-500/15 md:-translate-x-px"></div>
                <div className="space-y-8">
                  {milestones.map((item, index) => (
                    <ScrollReveal key={item.date}>
                      <div className={`relative flex flex-col md:flex-row gap-6 md:gap-10 ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'}`}>
                        <div className={`flex-1 ${index % 2 === 0 ? 'md:text-right' : 'md:text-left'} pl-10 md:pl-0`}>
                          <div className="absolute left-0 md:left-1/2 top-1 w-[9px] h-[9px] rounded-full bg-primary-500 border-2 border-background-950 md:-translate-x-1/2 transition-all duration-500 group-hover:scale-150 group-hover:shadow-[0_0_12px_rgba(180,140,80,0.6)]"></div>
                          <span className="text-primary-500 text-sm font-mono font-medium">{item.date}</span>
                          <h3 className="text-foreground-50 font-semibold text-lg mt-1 mb-2 group-hover:text-primary-500 transition-colors duration-300">{item.title}</h3>
                          <p className="text-secondary-400 text-sm leading-relaxed">{item.desc}</p>
                        </div>
                        <div className="flex-1 hidden md:block"></div>
                      </div>
                    </ScrollReveal>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Qualifications */}
        <section className="py-16 md:py-24 bg-background-900">
          <div className="w-full px-4 md:px-8 lg:px-12">
            <div className="max-w-screen-2xl mx-auto">
              <ScrollReveal>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50 mb-12 text-center">资质与合作背书</h2>
              </ScrollReveal>
              <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
                {[
                  { icon: 'ri-zhihu-line', label: '知乎官方战略合作企业' },
                  { icon: 'ri-global-line', label: '图兰朵海外深度合作企业' },
                  { icon: 'ri-copyright-line', label: 'AI漫剧工业化SOP软件著作权' },
                  { icon: 'ri-database-2-line', label: '文化数字资产归档系统版权' },
                  { icon: 'ri-award-line', label: '山西文旅数字化重点服务能力' },
                ].map((item) => (
                  <div key={item.label} className="group bg-background-800/40 rounded-xl border border-primary-500/10 p-5 text-center hover:border-primary-500/25 hover:-translate-y-1 transition-all duration-500 hover:shadow-[0_0_20px_rgba(180,140,80,0.1)] cursor-default">
                    <div className="w-10 h-10 mx-auto rounded-lg bg-primary-500/10 flex items-center justify-center mb-3 group-hover:bg-primary-500/20 group-hover:scale-110 transition-all duration-500">
                      <i className={`${item.icon} text-primary-500 text-lg`}></i>
                    </div>
                    <p className="text-secondary-300 text-xs leading-relaxed group-hover:text-foreground-50 transition-colors duration-300">{item.label}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
